import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import './Orb.css';

export type OrbVariant = 'violet' | 'lavender' | 'amber' | 'deep';
export type OrbSize = 'sm' | 'md' | 'lg' | 'xl';

export interface OrbProps extends HTMLAttributes<HTMLDivElement> {
  variant?: OrbVariant;
  size?: OrbSize;
  floating?: boolean;
}

export const Orb = forwardRef<HTMLDivElement, OrbProps>(function Orb(
  { variant = 'violet', size = 'md', floating = true, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      aria-hidden
      className={cn(
        'itb-orb-base',
        `itb-orb-base--${variant}`,
        `itb-orb-base--${size}`,
        floating && 'itb-orb-base--floating',
        className,
      )}
      {...rest}
    />
  );
});
